export enum GemBankType {
  POROLIS = 'porolis',
}
